import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { UserCheckIcon, UserIcon } from '@yonderland/andes-icons';
import { Icon, IconLink, Link } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { useOAuth } from '../../hooks/useOAuth';
import { NewAccountMenuPopover } from '../account/account-menu/NewAccountMenuPopover';
import { SecurityLevelsPopup } from '../security-levels-popup/SecurityLevelsPopup';
export const AccountMenuItem = ({ accountMenu, isDesktop }) => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const { authUrl, isLoggedIn, postLogin, logout } = useOAuth();
    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }
        postLogin();
    }, [isLoggedIn, postLogin]);
    const sharedMobileLinkProps = {
        icon: {
            title: 'user icon',
            source: isLoggedIn ? UserCheckIcon : UserIcon,
            size: 'xs',
            color: 'neutral',
            testId: 'account',
        },
        variant: 'plain',
        size: 'sm',
        testId: 'login-button',
    };
    if (isLoggedIn) {
        return (_jsxs(_Fragment, { children: [_jsx(NewAccountMenuPopover, { items: accountMenu, logout: logout }), _jsx(SecurityLevelsPopup, {})] }));
    }
    return isDesktop ? (_jsxs(Link, { testId: "login-button", theme: "neutral", variant: "tertiary", size: "sm", href: authUrl, children: [_jsx(Icon, { source: UserIcon, size: "xs" }), t('account.login.title.login')] })) : (_jsx(IconLink, Object.assign({ href: authUrl }, sharedMobileLinkProps)));
};
